<template>
  <div :class="classes">
    <cool-select
      v-model="selectedValue"
      :list="list"
      :option-value="optionValue"
      :option-text="optionText"
      :placeholder="placeholder"
    />
    <div class="icon-clear" @click="clearSelect">
      <svg width="10" height="10" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M.949597.00004154-6e-8 .949633 4.05038 5 0 9.05037l.949597.94959L4.99998 5.94959 9.0504 10 10 9.05041 5.94957 5 10 .949591 9.0504 0 4.99998 4.05041.949597.00004154Z"
          fill="#333"/>
      </svg>
    </div>
  </div>
</template>

<script>

export default {
  name: 'ClearableSelect',
  emits: ['input'],
  data() {
    return {
      selectedValue: ''
    }
  },
  model: {
    prop: 'modelValue',
    event: 'input'
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    optionValue: {
      type: String,
      default: ''
    },
    optionText: {
      type: String,
      default: ''
    },
    modelValue: {},
    placeholder: {
      type: String
    }
  },
  computed: {
    isEmpty() {
      return this.selectedValue === ''
    },
    classes() {
      return 'clearable-select' + (this.isEmpty ? '' : ' not-empty')
    }
  },
  watch: {
    modelValue: {
      handler(value) {
        if (this.selectedValue !== value) this.selectedValue = value
      },
      immediate: true
    },
    selectedValue(value) {
      this.$emit('input', value)
    }
  },
  methods: {
    clearSelect() {
      this.selectedValue = ''
    }
  }
}
</script>

<style lang="scss">
.clearable-select {
  .icon-clear {
    display: none;
    position: absolute;
    bottom: 9px;
    right: 20px;
    padding: 4px;
    cursor: pointer;

    svg {
      display: block;
    }
  }

  &.not-empty:hover {
    .dropdown.icon {
      display: none;
    }

    .icon-clear {
      display: block;
    }
  }
}
</style>
